module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    attrs: {
      "ng-cloak": ""
    }
  }, [(_vm.team) ? _c('router-link', {
    staticClass: "team-name",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v(_vm._s(_vm.team.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "search-form",
    attrs: {
      "id": "searchForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.performSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_query),
      expression: "search_query"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "text",
      "size": "30",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search_query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.search_query),
      expression: "!search_query"
    }],
    staticClass: "icon icon-search"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetSearch($event)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search_query),
      expression: "search_query"
    }],
    staticClass: "icon icon-remove"
  })])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "sepH2"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.search_query),
      expression: "!search_query"
    }],
    staticClass: "filters"
  }, [_c('a', {
    class: {
      active: _vm.activeFilter
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeFilter = true
      }
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('a', {
    class: {
      active: !_vm.activeFilter
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeFilter = null
      }
    }
  }, [_vm._v("All")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.areFilteredChannels),
      expression: "!areFilteredChannels"
    }]
  }, [_vm._v("Channels")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.areFilteredChannels === true),
      expression: "areFilteredChannels === true"
    }]
  }, [_vm._v("Filter by channel")])]), _vm._v(" "), _c('div', {
    staticClass: "shadow-container",
    attrs: {
      "id": "shadowContainer"
    }
  }, [_c('ul', {
    staticClass: "channels-list",
    attrs: {
      "id": "channelsList"
    }
  }, _vm._l((_vm.filteredChannels), function(each) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: (_vm.search_query ? 'channel_search' : 'channel'),
          params: {
            channel_name: each.name,
            search: _vm.search_query
          }
        },
        "id": 'channel-menu-' + each.name
      }
    }, [_vm._v("\n            # " + _vm._s(each.name) + "\n            "), (each.results) ? _c('span', {
      staticClass: "count"
    }, [_vm._v(_vm._s(each.results))]) : _vm._e()])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sofa-scrolling-shadow-top",
    attrs: {
      "id": "topShadow"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sofa-scrolling-shadow-bottom",
    attrs: {
      "id": "bottomShadow"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48aaed2d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBar.vue
// module id = 256
// module chunks = 2